{
  "version": 1,
  "asset_id": "211e2b98-3e0e-4584-bc67-bae37f84e2e3",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/211e2b98-3e0e-4584-bc67-bae37f84e2e3/lap-band-diagram.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/211e2b98-3e0e-4584-bc67-bae37f84e2e3/lap-band-diagram.jpg",
  "original_filename": "lap-band-diagram.jpg",
  "size": 101614,
  "content_type": "image/jpeg",
  "created_at": "2026-08-16T16:56:48Z"
}
